import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotifyOffFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 20,
	fill: "none",
	viewBox: "0 0 22 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M2.1875 2.1875L6.8125 5.78125C7.53125 4.6875 8.65625 3.875 10 3.625V3C10 2.46875 10.4375 2 11 2C11.5312 2 12 2.46875 12 3V3.625C14.2812 4.0625 16 6.09375 16 8.5V9.09375C16 10.5625 16.5312 12 17.5 13.0937L17.7188 13.3437C18 13.6562 18.0625 14.0625 17.9062 14.4375C17.9062 14.4375 17.875 14.4375 17.875 14.4687L20.6875 16.6875C21.0313 16.9375 21.0938 17.4062 20.8125 17.7187C20.5625 18.0625 20.0938 18.125 19.7813 17.8437L1.28125 3.34375C0.9375 3.09375 0.875 2.625 1.15625 2.3125C1.40625 1.96875 1.875 1.90625 2.1875 2.1875ZM13.6875 15L5 15C4.59375 15 4.21875 14.7812 4.0625 14.4375C3.90625 14.0625 3.96875 13.6562 4.25 13.3438L4.46875 13.0938C5.4375 12 6 10.5625 6 9.09375V8.96875L13.6875 15ZM12.4063 17.4375C12.0313 17.8125 11.5313 18 11 18C10.4688 18 9.9375 17.8125 9.5625 17.4375C9.1875 17.0625 9 16.5312 9 16H11H13C13 16.5312 12.7813 17.0625 12.4063 17.4375Z"
	})
});
const ForwardRef = forwardRef(SvgNotifyOffFilled);
export default ForwardRef;
